import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { MmiProjection } from '@app/finance';
import { formatEuros } from '@/lib/format';

export function ProjectionChart({ projection }: { projection: MmiProjection }) {
  const lastYear = projection.summary.saleYear - projection.years[0]!;
  let cumulative = projection.cashFlow.total[0] ?? 0;

  const data = Array.from({ length: lastYear + 1 }, (_, n) => {
    const annual = projection.cashFlow.total[n] ?? 0;
    if (n > 0) cumulative += annual;
    return { year: projection.years[n], annuel: annual, cumule: cumulative };
  });

  return (
    <div className="h-72 w-full">
      <ResponsiveContainer>
        <ComposedChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis dataKey="year" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} tickFormatter={(value: number) => formatEuros(value)} width={90} />
          <Tooltip formatter={(value) => formatEuros(Number(value))} />
          <Legend />
          <Bar dataKey="annuel" name="Cash-flow annuel" fill="var(--color-primary)" />
          <Line type="monotone" dataKey="cumule" name="Position cumulée" stroke="var(--color-muted-foreground)" strokeWidth={2} dot={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
